export default __webpack_public_path__ + "static/media/nndss.9952879d.png";